declare global {
  const WorkerGlobalScope: any;
}

// Is Node.js? (probably server context of Next.js)
export const isServer = typeof window === 'undefined';

// Browser contexts
export const isClient = typeof window !== 'undefined';

export const isRedirectingToDevEnvironment =
  process.env.SIGN_IN_REDIRECT_URL?.includes('dev.frame.io');
